export default __webpack_public_path__ + "static/223-b85ffafe5997ab6c792f16b7a06b91ba.gif";